export default __webpack_public_path__ + "static/media/azure-ml.00d28799.svg";